import { useEffect } from 'react';
import { type UpdateQueryParameterValues, type FilterKey } from '../../../../hooks/use-update-query-parameter-values';
import { type PieChartItem } from '@/utils/draw-pie-chart';

interface UseSyncSelectedChartSegmentProperties {
  selectedChartItem: PieChartItem | null;
  indexKey: string;
  searchParameters: URLSearchParams;
  updateQueryParameterValues: UpdateQueryParameterValues;
  resetSelectedChartItem: () => void;
}

const useSyncSelectedChartSegment = ({
  selectedChartItem,
  indexKey,
  searchParameters,
  updateQueryParameterValues,
  resetSelectedChartItem,
}: UseSyncSelectedChartSegmentProperties): void => {
  useEffect(() => {
    if (!selectedChartItem) {
      return;
    }

    // To avoid linting error when resetting selectedChartItem immediately
    const resetAsync = async (): Promise<void> => {
      resetSelectedChartItem();
      await new Promise((resolve) => {
        const timer = setTimeout(resolve, 0);
        clearTimeout(timer);
      });
    };

    void resetAsync();

    const newValue = selectedChartItem.segmentIndex.toString();
    const previousValue = searchParameters.get(indexKey);

    updateQueryParameterValues({
      filterKeys: {
        [indexKey as FilterKey]: previousValue === newValue ? [] : [newValue],
      },
    });
  }, [selectedChartItem, indexKey, searchParameters, updateQueryParameterValues, resetSelectedChartItem]);
};

export default useSyncSelectedChartSegment;
